import { MigrationInterface, QueryRunner } from 'typeorm'

export class AddUserEntity1696423481816 implements MigrationInterface {
	name = 'AddUserEntity1696423481816'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(
			`CREATE TABLE "user_credentials" ("id" uuid NOT NULL DEFAULT uuid_generate_v4(), "createdAt" TIMESTAMP NOT NULL DEFAULT now(), "password" text NOT NULL, CONSTRAINT "PK_5cadc04d03e2d9fe76e1b44eb34" PRIMARY KEY ("id"))`,
		)
		await queryRunner.query(
			`CREATE TABLE "user" ("id" uuid NOT NULL DEFAULT uuid_generate_v4(), "createdAt" TIMESTAMP NOT NULL DEFAULT now(), "deletedAt" TIMESTAMP, "firstName" character varying(60) NOT NULL, "lastName" character varying(60) NOT NULL, "email" character varying(255) NOT NULL, "emailVerified" boolean NOT NULL DEFAULT false, "credentialsId" uuid, CONSTRAINT "REL_9f92e2173d4e8d981fe96cfdec" UNIQUE ("credentialsId"), CONSTRAINT "PK_cace4a159ff9f2512dd42373760" PRIMARY KEY ("id"))`,
		)
		await queryRunner.query(
			`ALTER TABLE "user" ADD CONSTRAINT "FK_9f92e2173d4e8d981fe96cfdec9" FOREIGN KEY ("credentialsId") REFERENCES "user_credentials"("id") ON DELETE NO ACTION ON UPDATE NO ACTION`,
		)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "user" DROP CONSTRAINT "FK_9f92e2173d4e8d981fe96cfdec9"`)
		await queryRunner.query(`DROP TABLE "user"`)
		await queryRunner.query(`DROP TABLE "user_credentials"`)
	}
}
